export const ContentOptions = {
  showTitle: true,
  showSubtitle: true,
  showCategory: true,
  showContent: true,
  showDate: true,
  showIcon: false,
  showTimeToRead: true,
};
